exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".branding-row__3ezny .set-default-button__3INMB {\n  margin-top: -2px;\n  margin-bottom: -2px; /* To avoid table shifting. There is 4px difference of heigh between button and default badge */\n  visibility: hidden;\n}\n\n.branding-row__3ezny:hover .set-default-button__3INMB {\n  visibility: visible;\n}\n", ""]);

// Exports
exports.locals = {
	"branding-row": "branding-row__3ezny",
	"set-default-button": "set-default-button__3INMB"
};